export default {
  SEND_ANSWER: "sendAnswer",
  SUBMIT_ANSWERS: "submitAnswers",
  SHOW_TOASTER: "showTaster",
};
